import { useEffect, useRef, useState } from 'react';
import PageContainer from '../../components/PageContainer';
import { useSearchParams } from "react-router-dom";
import Loader from '../../components/Loader';
import { GreenButton } from '../../components/buttons';
import { useTranslation } from 'react-i18next';

const UserPurchaseResult = () => {
    const { t } = useTranslation();
    const [searchParams] = useSearchParams();
    const session_id = searchParams.get('session_id');
    const requestId = searchParams.get('requestId');
    const [fetchStatus, setFetchStatus] = useState('loading');
    const [error, setError] = useState(null);
    const hasFetched = useRef(false);

    useEffect(() => {
        if (hasFetched.current) return;

        if (!requestId || !session_id) {
            setFetchStatus('failed');
            setError(t('UserPurchaseResult.errMissingParams'));
            hasFetched.current = true;
            return;
        }

        const auth = localStorage.getItem('ticino-wild-token');
        if (!auth) {
            setFetchStatus('failed');
            setError(t('UserPurchaseResult.errNotLogged'));
            hasFetched.current = true;
            return;
        }

        hasFetched.current = true;

        const processRequest = async () => {
            const headers = { 'Content-Type': 'application/json', Authorization: `Bearer ${auth}` };
            try {
                const statusUrl = `${process.env.REACT_APP_SERVER_BASE_URL}/requests/get-request-status/${requestId}`;
                const statusRes = await fetch(statusUrl, { method: 'GET', headers });
                const statusData = await statusRes.json();
                if (!statusRes.ok) {
                    throw new Error(statusData.message || 'Impossibile verificare lo stato della richiesta.');
                }

                if (statusData.status !== 'purchased') {
                    const fallbackUrl = `${process.env.REACT_APP_SERVER_BASE_URL}/requests/final-purchase-step/${requestId}`;
                    const fallbackRes = await fetch(fallbackUrl, {
                        method: 'PATCH',
                        headers,
                        body: JSON.stringify({ sessionId: session_id })
                    });
                    if (!fallbackRes.ok) {
                        const err = await fallbackRes.json();
                        throw new Error(err.message || 'Errore nella conferma del pagamento.');
                    }
                }

                setFetchStatus('succeeded');
            } catch (err) {
                console.error('Errore nel processare la richiesta:', err);
                setError(err.message || 'Errore nel gestire la richiesta.');
                setFetchStatus('failed');
            }
        };

        processRequest();
    }, [requestId, session_id, t]);

    return (
        <PageContainer items="center">
            {/* Titolo legato all'esito reale: la pagina è raggiungibile anche chiudendo il
                browser in-app senza pagare (browserFinished), quindi niente titolo affermativo
                finché la conferma server non è andata a buon fine. */}
            {fetchStatus === 'succeeded' && <h2>{t('UserPurchaseResult.paymentSuccess')}</h2>}
            {fetchStatus === 'failed' && <h2>{t('UserPurchaseResult.paymentNotCompleted')}</h2>}
            {fetchStatus === 'loading' &&
                <div className='mt-8'>
                    <Loader />
                </div>
            }
            {fetchStatus === 'failed' &&
                <div className='mt-8'>
                    <div>{error}</div>
                    <div>{t('UserPurchaseResult.errContact')} {requestId}</div>
                </div>
            }
            {fetchStatus === 'succeeded' &&
                <div className='mt-8 flex flex-col gap-4 items-center text-center'>
                    <h3 className='text-green-500'>{t('UserPurchaseResult.congrats')}</h3>
                    <p>{t('UserPurchaseResult.recapBody')}</p>
                    <GreenButton text={t('UserPurchaseResult.backHome')} link="/" click={() => window.location.href = '/'} />
                </div>
            }
        </PageContainer>
    )
}

export default UserPurchaseResult;
